import {
  ApiResponseType,
  API_ROUTES,
  IPageRequestParams,
  ITravellerDetailsResponseData,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { CONTEXT, LOB, PARTNER, PLATFORM } from "@tm/isomorphic-utils";
import {
  getHTTPRoutePrefix,
  getLobOnServerSide,
  getPathPartnerOnServerSide,
} from "@tm/server-utils";
import { AxiosResponse } from "axios";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getTravelAttributes = async (
  reqData: IPageRequestParams
): Promise<AxiosResponse<ApiResponseType<ITravellerDetailsResponseData>>> => {
  const { partner = PARTNER.MMT, headers, cmp, query, dvid } = reqData || {};
  const headerCmp = resolveCmpForApiRequest(cmp, query);

  const {
    isUpcomingTrip,
    bookingId,
    countries,
    startDate,
    endDate,
    travellers,
    ...queryParams
  } = query || {};

  const params = {
    lob: getLobOnServerSide(partner) || LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    travelPurpose: "Leisure Trip",
    ...(isUpcomingTrip && {
      upcomingTraveller: isUpcomingTrip === "true" ? true : false,
    }),
    ...(bookingId && { booking_id: bookingId.toString() }),
    ...(countries && { countryCodes: countries.toString() }),
    ...(startDate && { departureDateTime: Number(startDate) }),
    ...(endDate && { arrivalDateTime: Number(endDate) }),
    ...(travellers && { numberOfTravellers: Number(travellers) }),
    ...queryParams,
  };

  const urlParams = setURLQueryParams(params);
  const httpRoutePrefix = getHTTPRoutePrefix(partner);
  const pathPartner = getPathPartnerOnServerSide(partner);

  const url = `${httpRoutePrefix}/${pathPartner}/${
    API_ROUTES.GET_TRAVEL_ATTRIBUTES
  }${urlParams ? `?${urlParams}` : ""}`;

  const response = await API_HTTP.get(url, {
    headers: { ...headers, cmp: headerCmp || "fallback", dvid },
  });
  return response;
};
